import { useEffect, useState } from 'react';
import { fetchJobListings } from './jobListingsService';

const useJobListings = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const loadJobs = async () => {
      setLoading(true);
      setError(null);

      try {
        const listings = await fetchJobListings();
        if (!cancelled) {
          setJobs(listings);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load job listings.');
          setJobs([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadJobs();

    return () => {
      cancelled = true;
    };
  }, []);

  return { jobs, loading, error };
};

export default useJobListings;
